export const RETURNS_MODES = Object.freeze({
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED'
});
